export const NAMESPACE = 'botspecs';
